import {NgModule} from '@angular/core';
import {CommonModule, CurrencyPipe} from '@angular/common';

import {DashboardRoutingModule} from './dashboard-routing.module';
import {DashboardComponent} from './dashboard/dashboard.component';
import {DashboardHostComponent} from './dashboard-host.component';
import {DashboardV2Component} from './dashboard-v2/dashboard-v2.component';
import {FormsModule} from "@angular/forms";
import {NgxSpinnerModule} from "ngx-spinner";
import {SharedModule} from "@shared/shared.module";
import {RedemptionPointModule} from "@app/features/redemption-point/redemption-point.module";


@NgModule({

  imports: [
    CommonModule,
    DashboardRoutingModule,
    FormsModule,
    NgxSpinnerModule,
    SharedModule,
    RedemptionPointModule
  ],
  providers: [CommonModule, CurrencyPipe
  ],
  declarations: [
    DashboardComponent,
    DashboardHostComponent,
    DashboardV2Component
  ],
})
export class DashboardModule {
}
